export default __webpack_public_path__ + "static/media/16.b3c20fa5.png";